import { css } from "@emotion/react";

export const receiptButtonStyle = css`
  width: 132px;
`;
